import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import './Responsive.css'
import { BrowserRouter, Routes, Route } from 'react-router-dom';
// influencer
import Home from './Pages/Home';
import Login from './Pages/Login';
import Register from './Pages/Register';
import Dashboard from './Pages/Dashboard';
import Profile from './Pages/Profile';
import Campaigns from './Pages/Campaigns';
import Earnings from './Pages/Earnings';
import Messages from './Pages/Messages';
import EditProfile from './Pages/EditProfile';
import ViewUser from './Pages/ViewUser';
//user
import UserDashboard from './Pages/User/UserDashboard';
import UserInfluencers from './Pages/User/UserInfluencers';
import UserMessages from './Pages/User/UserMessages';
import UserProfile from './Pages/User/UserProfile';
import UserAds from './Pages/User/UserAds';
import RunAds from './Pages/User/RunAds';
import UserEditProfile from './Pages/User/UserEditProfile';
import UserViewAd from './Pages/User/UserViewAd';

//components
import ProtectedRoute from './Components/ProtectedRoute';
import { LocationProvider } from './Components/LocationContext';
import GetStarted from './Pages/User/GetStarted';
import UserSubscribe from './Pages/User/UserSubscribe';
import TermsOfService from './Pages/TermsOfService';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import ForgotPassword from './Pages/ForgotPassword';
import ViewAd from './Pages/ViewAd';
import Withdraw from './Pages/Withdraw';
import ViewMedia from './Pages/ViewMedia';
import ViewSubs from './Pages/ViewSubs';
import VerifyAccount from './Pages/VerifyAccount';
import UserViewSubs from './Pages/User/UserViewSubs';
import UserViewMedia from './Pages/User/UserViewMedia';
import SubmitAds from './Pages/User/SubmitAds';
import SubscriptionSetup from './Pages/SubscriptionSetup';
import SocialSetup from './Pages/SocialSetup';
import UserNameSetup from './Pages/UserNameSetup';

function App() {
  return (
    <div className="App">
      <LocationProvider>
        <BrowserRouter>
          <Routes>
            {/* influencer stuff */}
            <Route path="/dashboard" element={
              <ProtectedRoute allowedRoles={["An Influencer"]}>
                <Dashboard />
              </ProtectedRoute>
            } />
            <Route path="/profile" element={
              <ProtectedRoute allowedRoles={["An Influencer"]}>
                <Profile />
              </ProtectedRoute>
            } />
            <Route path="/campaigns" element={
              <ProtectedRoute allowedRoles={["An Influencer"]}>
                <Campaigns />
              </ProtectedRoute>
            } />
            <Route path="/earnings" element={
              <ProtectedRoute allowedRoles={["An Influencer"]}>
                <Earnings />
              </ProtectedRoute>
            } />
            <Route path="/messages" element={
              <ProtectedRoute allowedRoles={["An Influencer"]}>
                <Messages />
              </ProtectedRoute>
            } />
            <Route path="/edit-profile" element={
              <ProtectedRoute allowedRoles={["An Influencer"]}>
                <EditProfile />
              </ProtectedRoute>
            } />
            <Route path="/view-ad/:adId" element={
              <ProtectedRoute allowedRoles={["An Influencer"]}>
                <ViewAd />
              </ProtectedRoute>
            } />
            <Route path="/withdraw" element={
              <ProtectedRoute allowedRoles={["An Influencer"]}>
                <Withdraw />
              </ProtectedRoute>
            } />

            <Route path="/view-media/:adId" element={
              <ProtectedRoute allowedRoles={["An Influencer"]}>
                <ViewMedia />
              </ProtectedRoute>
            } />

            <Route path="/view-subs/:adId" element={
              <ProtectedRoute allowedRoles={["An Influencer"]}>
                <ViewSubs />
              </ProtectedRoute>
            } />

            <Route path="/verify-account" element={
              <ProtectedRoute allowedRoles={["An Influencer"]}>
                <VerifyAccount />
              </ProtectedRoute>
            } />

            <Route path="/username-setup" element={
              <ProtectedRoute allowedRoles={["An Influencer"]}>
                <UserNameSetup />
              </ProtectedRoute>
            } />

            <Route path="/subs-setup" element={
              <ProtectedRoute allowedRoles={["An Influencer"]}>
                <SubscriptionSetup />
              </ProtectedRoute>
            } />

            <Route path="/social-setup" element={
              <ProtectedRoute allowedRoles={["An Influencer"]}>
                <SocialSetup />
              </ProtectedRoute>
            } />

            {/* user stuff*/}
            <Route path="/user/dashboard" element={
              <ProtectedRoute allowedRoles={["A user"]}>
                <UserDashboard />
              </ProtectedRoute>
            } />
            <Route path="/user/profile" element={
              <ProtectedRoute allowedRoles={["A user"]}>
                <UserProfile />
              </ProtectedRoute>
            } />
            <Route path="/user/influencers" element={
              <ProtectedRoute allowedRoles={["A user"]}>
                <UserInfluencers />
              </ProtectedRoute>
            } />
            <Route path="/user/messages" element={
              <ProtectedRoute allowedRoles={["A user"]}>
                <UserMessages />
              </ProtectedRoute>
            } />
            <Route path="/user/ads" element={
              <ProtectedRoute allowedRoles={["A user"]}>
                <UserAds />
              </ProtectedRoute>
            } />
            <Route path="/user/run-ads" element={
              <ProtectedRoute allowedRoles={["A user"]}>
                <RunAds />
              </ProtectedRoute>
            } />
            <Route path="/user/edit-profile" element={
              <ProtectedRoute allowedRoles={["A user"]}>
                <UserEditProfile />
              </ProtectedRoute>
            } />

            <Route path="/user/get-started/:id" element={
              <ProtectedRoute allowedRoles={["A user"]}>
                <GetStarted />
              </ProtectedRoute>
            } />

            <Route path="/user/subscribe/:id" element={
              <ProtectedRoute allowedRoles={["A user"]}>
                <UserSubscribe /> 
              </ProtectedRoute>
            } />

            <Route path="/user/view-ad/:adId" element={
              <ProtectedRoute allowedRoles={["A user"]}>
                <UserViewAd />
              </ProtectedRoute>
            } />

            <Route path="/user/view-subs/:adId" element={
              <ProtectedRoute allowedRoles={["A user"]}>
                <UserViewSubs />
              </ProtectedRoute>
            } />

            <Route path="/user/view-media/:adId" element={
              <ProtectedRoute allowedRoles={["A user"]}>
                <UserViewMedia />
              </ProtectedRoute>
            } />

            <Route path="/user/submit-ads" element={
              <ProtectedRoute allowedRoles={["A user"]}>
                <SubmitAds />
              </ProtectedRoute>
            } />

            {/* global stuff */}
            <Route path="/:username" element={<ViewUser />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/" element={<Home />} />

          </Routes>
        </BrowserRouter>
      </LocationProvider>
    </div>
  );
}

export default App;
